import { styled, StyleSheet } from '@rexlabs/styling';
import React, { PureComponent } from 'react';
import { TEXTS } from 'src/theme';

const defaultStyles = StyleSheet({
  heading: TEXTS.HEADING
});

@styled(defaultStyles)
class Heading extends PureComponent {
  static defaultProps = {
    Tag: 'h1'
  };

  render() {
    const { Tag, styles: s, children, ...rest } = this.props;
    return (
      <Tag {...s.with('heading')(this.props)} {...rest}>
        {children}
      </Tag>
    );
  }
}

export default Heading;
